<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a href="/admin/driversList/">Drivers</a></li>
      <li class="breadcrumb-item active" aria-current="page">Edit Driver</li>
    </ol>
  </nav>
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black">Driver Details</h2>
          <div class="row mt-3">
            <div class="col-md-12 col-md-8">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <div>Email</div>
                    <div><b>{{editDriver.email}}</b></div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <div>Phone Number</div>
                    <div><b>{{editDriver.mobileNumber}}</b></div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 required">
                  <div class="form-group">
                    <label class="control-label" for="companyName">Driver Name</label>
                    <input type="text" id="companyName" [(ngModel)]="editDriver.driverName" class="form-control"
                           (blur)="typeDriverName()" [ngClass]="{'is-invalid':statusText2}"
                           [ngModelOptions]="{standalone: true}" required>
                  </div>
                  <div id="statusText1" class="invalid-feedback d-block shift-invalid-text"
                       [hidden]="!statusText2">{{statusText2}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3" *ngFor="let add of addresses">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black mb-3">Address</h2>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group mt-3 required">
                <label class="control-label" for="addressType">Address Type</label>
                <select id="addressType" class="form-control" [(ngModel)]="add.addressType"
                        [ngModelOptions]="{standalone: true}" required>
                  <option *ngFor="let a of addressTypes" [ngValue]="a.config">{{a.config}}</option>
                </select>
                <div id="statusText3" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!statusText3">{{statusText3}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group required">
                <label class="control-label" for="address1">Address1</label>
                <input type="text" id="address1" [(ngModel)]="add.address1" class="form-control" (blur)="typeAddress()"
                       [ngClass]="{'is-invalid':statusText4}" [ngModelOptions]="{standalone: true}" required>
                <div id="statusText4" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!statusText4">{{statusText4}}</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="control-label" for="address2">Address2</label>
                <input type="text" id="address2" [(ngModel)]="add.address2" class="form-control"
                       [ngModelOptions]="{standalone: true}" required>
              </div>
            </div>
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label">City</label>
                <ng-select type="text" id="city" placeholder="City" [(ngModel)]="add.city" [items]="citiesList" [addTag]="true"
                           (blur)="typeCity()" [ngClass]="{'is-invalid':statusText5}"
                           [ngModelOptions]="{standalone: true}" required>
                </ng-select>
                <div id="statusText5" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!statusText5">{{statusText5}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 required">
              <div class="form-group required ">
                <label class="control-label">State</label>

                <ng-select id="State" [(ngModel)]="add.state" [ngModelOptions]="{standalone: true}"
                           [ngClass]="{'service-error':statusText6}"
                           (blur)="typeState()"
                           [ngClass]="{'is-invalid':statusText6}"
                           [items]="statesList"
                           placeholder="State">
                </ng-select>

                <!--
                                      <input type="text" id="accountStateAlt" [(ngModel)]="add.state" class="form-control" (blur)="typeState()" [ngClass]="{'is-invalid':statusText6}" [ngModelOptions]="{standalone: true}"   required>
                -->
                <div id="statusText6" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!statusText6">{{statusText6}}</div>
              </div>
            </div>
            <div class="col-md-4 required">
              <div class="form-group  ">
                <label class="control-label" for="accountZipAlt">Zip</label>
                <input type="text" id="accountZipAlt" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                       maxlength="6" placeholder="Enter PinCode" (change)="changeStateAndCity()" [(ngModel)]="add.zip"
                       class="form-control" (blur)="typeZip()" [ngClass]="{'is-invalid':statusText7}"
                       [ngModelOptions]="{standalone: true}" required>
                <div id="statusText7" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!statusText7">{{statusText7}}</div>
              </div>
            </div>
            <!--  <div class="col-md-4">
                <div class="form-group">
                  <label class="control-label" for="geoCode">Geo Code</label>
                  <input type="text" id="geoCode" onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="6" [(ngModel)]="add.geoCode" class="form-control"  [ngModelOptions]="{standalone: true}" required>
              </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/driversList" id="cancel" class="btn btn-cancel">Cancel</button>
      <button type="submit" (click)="submitDriver()" id="save" class="btn btn-orange-prime ml-2">Save</button>
    </div>
  </div>
</div>
